var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetadataConfiguration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0v10h-.672l-1-1H15V1H1v8h4v1H0V0h16zm-2.086 10h-4.5C8.28 11.14 7.141 12.279 6 13.414V2.086L13.914 10zM11.5 9L7 4.5V11l2-2h2.5z",
    fill: "currentColor"
  })));
}

export default SvgMetadataConfiguration;